module.exports = __webpack_public_path__ + "static/media/shakti.95ebb734.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/shakti.jpg
// module id = 724
// module chunks = 0